import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { handleError, handleSuccess } from '../utils';
import { ToastContainer } from 'react-toastify';
import './Sidebar.css';

function Sidebar() {
  const [loggedInUser, setLoggedInUser] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    setLoggedInUser(localStorage.getItem('loggedInUser'));
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('loggedInUser');
    handleSuccess('User Logged out');
    setTimeout(() => {
      window.location.reload(); // Reload the page
      navigate('/login'); // Navigate to the login page
    }, 1000);
  };

  return (
    <div>
      <div className="admin__sidebar">
        <div className="admin__brand">
          <img
            className="admin__logo"
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSj3aGhHnXM2zmul3dBNpB5SYSsLvD0d35c0w&s"
            alt="Logo"
          />
          <span className="admin__brand-name">
            <Link className="link" to="/home">
            </Link>
          </span>
        </div>

        <ul className="admin__menu">
          {/* Zoho Connect */}
          <li className="admin__menu-item">
            <a href="/auth/zohologin" className="admin__menu-link">
              <i className="fa fa-plug admin__menu-icon"></i>
              <span className="admin__menu-text">Zoho Connect</span>
            </a>
          </li>

          {/* Parent Form */}
          <li className="admin__menu-item">
            <a href="https://connect.youngengineers.org/" target="_blank" rel="noopener noreferrer" className="admin__menu-link">
              <i className="fas fa-users admin__menu-icon"></i>
              <span className="admin__menu-text">Parent Form</span>
            </a>
          </li>

          {/* Questions */}
          <li className="admin__menu-item">
            <Link className="admin__menu-link" to="/event">
              <i className="fas fa-question-circle admin__menu-icon"></i>
              <span className="admin__menu-text">Questions</span>
            </Link>
          </li>




        
        </ul>

        <div className="admin__logout" onClick={handleLogout}>
          <i className="fas fa-sign-out-alt admin__logout-icon"></i>
          <span className="admin__logout-text">Logout</span>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
